import React from 'react';
import { resolveHubupAssetUrl } from '../../api/hubup';

const EMPTY_LABEL = 'non renseigné';

const cardShadow =
  '0 2px 8px 0 rgba(132, 94, 247, 0.08), 0 1px 3px 0 rgba(0, 0, 0, 0.06)';

function stripHtml(html) {
  if (!html) return '';
  return String(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export default function CommunityPublicProfilePreview({
  profileTitle = '',
  profileDescription = '',
  profileAdditionalInfoHtml = '',
  groupIconUrl = '',
}) {
  const title = String(profileTitle ?? '').trim();
  const description = String(profileDescription ?? '').trim();
  const additionalHtml = String(profileAdditionalInfoHtml ?? '').trim();
  const hasAdditional = stripHtml(additionalHtml).length > 0;
  const iconSrc = resolveHubupAssetUrl(groupIconUrl);

  return (
    <div className="relative mx-auto w-full max-w-sm px-1">
      <div className="relative z-10 flex justify-center">
        <div
          className="flex h-24 w-24 sm:h-28 sm:w-28 shrink-0 items-center justify-center overflow-hidden rounded-full border-4 border-white bg-white ring-1 ring-[#E8E4FF]"
          style={{ boxShadow: cardShadow }}
        >
          {iconSrc ? (
            <img
              src={iconSrc}
              alt=""
              className="h-full w-full object-cover"
            />
          ) : (
            <span className="px-2 text-[10px] italic text-[#6B7280] text-center leading-snug">
              {EMPTY_LABEL}
            </span>
          )}
        </div>
      </div>

      <div
        className="relative z-0 -mt-12 sm:-mt-14 rounded-3xl border border-[#E8E4FF] bg-white px-4 pb-5 pt-14 sm:px-5 sm:pb-6 sm:pt-[4.25rem] text-center"
        style={{ boxShadow: cardShadow }}
      >
        <h2
          className={`text-xl font-bold leading-tight sm:text-2xl ${
            title
              ? 'text-[#1E1B4B]'
              : 'text-[#6B7280] italic font-normal text-base sm:text-lg'
          }`}
        >
          {title || EMPTY_LABEL}
        </h2>

        <p
          className={`mt-2.5 text-sm leading-relaxed ${
            description ? 'text-[#333483]' : 'text-[#6B7280] italic'
          }`}
        >
          {description || EMPTY_LABEL}
        </p>

        {hasAdditional ? (
          <div
            className="mt-4 w-full border-t border-[#E8E4FF] pt-4 text-left text-sm text-[#333483] leading-relaxed [&_a]:text-[#010064] [&_a]:underline [&_h2]:text-base [&_h2]:font-bold [&_h3]:text-sm [&_h3]:font-bold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-1 [&_img]:max-w-full [&_img]:h-auto [&_img]:rounded-md [&_img]:my-2 [&_video]:max-w-full [&_video]:w-full [&_video]:h-auto [&_video]:rounded-md [&_video]:my-2 [&_video]:bg-black"
            dangerouslySetInnerHTML={{ __html: additionalHtml }}
          />
        ) : null}
      </div>
    </div>
  );
}
